import { Directive } from '@angular/core'

@Directive({ selector: 'modal-buttons, modal-content, modal-header, modal-upsell' })
export class ModalButtons {
  // No behavior
  // The only purpose is to "declare" the tag in Angular2
}
